import { useState } from 'react';
import SpecSourceBadge from "./SpecSourceBadge";
import { stringToColor } from '../../../components/common/colorUtils';
import { IconButton } from '../../../components/common/IconButton';

export default function SpecSourcesList({ sourceIds, small = false, showContext = true, className = '' }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const count = (sourceIds || []).length;

  if (count === 0) {
    return null;
  }

  const toggleExpand = () => setIsExpanded(!isExpanded);

  const badgeSize = small ? 20 : 40;

  return (
    <div className={"inline-flex items-center " + className}>
      {isExpanded || count <= 1 ? (
        <>
          {(sourceIds || []).map(id => <SpecSourceBadge key={id} sourceId={id} small={small} showContext={showContext} />)}
          {count > 1 && <IconButton onClick={toggleExpand} className="px-2 text-xs text-gray-500 hover:text-gray-700" title="Collapse Sources" icon='expand_less' />}
        </>
      ) : (
        <div className="d-inline-block position-relative" title={`Show all ${count} sources`}>
          <span className="badge badge-dark badge-pill position-absolute" style={{top: '38px', left: '10px'}}>
            {count}
          </span>

          <SpecSourceBadge sourceId={(sourceIds || [])[0]} small={small} showContext={showContext} />

          <div className="text-center" onClick={toggleExpand} >
            {(sourceIds || []).slice(1,6).map((id, index) => (
              <div
                key={id}
                className="rounded-bottom border border-top-0 border-light inline-block"
                style={{
                  width: `calc(100% - ${(index+1) * 3}px)`,
                  height: `3px`,
                  backgroundColor: stringToColor(id) + '99',
                  // marginLeft: '-3px',
                  zIndex: -index -1
                }}
                title={`Source ID: ${id}`}
              />
            ))}
            <IconButton onClick={toggleExpand} style={{marginTop: '-12px'}} title="Collapse Sources" icon='expand_more' />
          </div>
        </div>
      )}
    </div>
  );
}